goog.provide("shadow.js.shim.module$src$svg$type$file_type$json_svg");
goog.provide("module$shadow_js_shim_module$src$svg$type$file_type$json_svg");
shadow.js.shim.module$src$svg$type$file_type$json_svg = shadow.js.nativeProvides["src/svg/type/file_type/json.svg"] = shadow$bridge("src/svg/type/file_type/json.svg");
module$shadow_js_shim_module$src$svg$type$file_type$json_svg.default = shadow.js.shim.module$src$svg$type$file_type$json_svg;
